import React from 'react';

const GuideLanding = () => {

  return (
    <div>
      <h1>Laxy Guide</h1>
    </div>
  );
};

export default GuideLanding;